import { View, Text } from "react-native";
import { colors, typography, spacing, radii } from "../theme/tokens";

type SummaryItem = {
  title: string;
  description: string;
};

type Props = {
  items: SummaryItem[];
  accentColor?: string;
};

export function QuickSummaryGrid({ items, accentColor = colors.warm }: Props) {
  if (items.length === 0) return null;

  return (
    <View
      style={{
        borderRadius: radii.lg,
        backgroundColor: `${accentColor}08`,
        borderWidth: 1,
        borderColor: `${accentColor}20`,
        padding: spacing.lg,
        gap: spacing.md,
      }}
    >
      {items.map((item, index) => (
        <View key={index} style={{ gap: 2 }}>
          <Text
            style={{
              fontFamily: typography.families.sansBold,
              fontSize: typography.sizes.base,
              color: colors.text,
            }}
          >
            {item.title}
          </Text>
          <Text
            style={{
              fontFamily: typography.families.sans,
              fontSize: typography.sizes.base,
              color: colors.textMid,
              lineHeight: typography.sizes.base * 1.5,
            }}
          >
            {item.description}
          </Text>
        </View>
      ))}
    </View>
  );
}
